import logo from '@/assets/images/logo/LogoQLRVnew.svg'
import LoginModal from '@/components/common/Login/MainLogin/LoginModal'
import ButtonCustom from '@/components/ui/ui-react-antd/MyButton/Button'
import ROUTER from '@/routes/ROUTER'
import { STORAGE, getLocalStorage } from '@/shared/utils/storage'
import { Avatar, Col, Popover, Row, Space } from 'antd'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import MenuUser from './MenuUser'
import './index.scss'
import { useRouterContext } from '@/shared/context'
import { useIsLogin } from '@/shared/context'
import { useAppDispatch } from '@/shared/redux/hooks'
import { setUserInfo } from '@/shared/redux/slices/appGlobal.slice'

const TopHeader = () => {
  const dispatch = useAppDispatch()
  const { setRouterBefore: setRouterBeforeLogin } = useRouterContext()
  const { setIsLogin: setIsLoginContext } = useIsLogin()

  // State để quản lý modal đăng nhập
  const [_isLoginModalOpen, _setIsLoginModalOpen] = useState(false)
  const [pendingAction, setPendingAction] = useState<any>('')
  const isLogin = getLocalStorage(STORAGE.TOKEN) || false
  const navigate = useNavigate()
  const isAdmin = false
  const [showLogin, setShowLogin] = useState(false)
  const { userInfo } = useSelector((state: any) => state?.appGlobal)
  const handleLoginSuccess = (userInfo: any) => {
    setShowLogin(false)

    // Thực hiện action đã lưu trước đó

    setRouterBeforeLogin(pendingAction.type)
    navigate(pendingAction.route)
    setPendingAction(null)
    setIsLoginContext(userInfo)
    dispatch(setUserInfo(userInfo))
    window.location.reload()
  }
  return (
    <div>
      <Row gutter={[12, 0]} className="d-flex-sb" style={{ width: '100%' }}>
        <Col>
          <div
            className={`name-branch d-flex ml-2 ${isAdmin ? '' : 'hover-menu'}`}
            onClick={() => {
              if (!isAdmin) navigate(ROUTER.HOME)
            }}
          >
            <img className="logo-page" src={logo} width={30} height={30} alt="Logo QLRV" />
            <div className={`fw-600 d-flex-start ml-2 `}>
              <div className={`name-branch-top`}>CheckInPRO</div>
            </div>
          </div>
        </Col>
        <Col>
          <div className="d-flex-end">
            <Space size={25}>
              {isLogin ? (
                <Popover content={<MenuUser />} trigger="hover" placement="bottomRight">
                  <Row gutter={5} className="pointer account-infor-sumary-border">
                    <Col>
                      <div className="account-infor">
                        <Avatar src={userInfo?.avatar} size={32} className="style-avt" />
                        <div className="account-infor-sumary">
                          {!!userInfo?.fullName && (
                            <div className="account-infor-sumary-fullname">{userInfo.fullName}</div>
                          )}
                          <div className="account-infor-sumary-position">{userInfo?.username}</div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Popover>
              ) : (
                <>
                  <ButtonCustom className="btn-login-header" onClick={() => setShowLogin(true)}>
                    Đăng nhập
                  </ButtonCustom>
                  <LoginModal
                    open={showLogin}
                    onCancel={() => setShowLogin(false)}
                    onLoginSuccess={handleLoginSuccess}
                    setOpenForgetPassModal={() => {
                      setShowLogin(false)
                    }}
                  />
                </>
              )}
            </Space>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default TopHeader
